import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout } from "antd";
import IcoLogoBlue from "assets/images/logo-blue-small.png";
import clsx from "clsx";
import { STORAGE } from "constant";
import { ContextModule } from "models";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { pageRoutes } from "routes";
import TokenStorageService from "services/storage";
import { StorageUtil } from "utils/storage";
import ProtectedHeader from "./Header";
import "./Protected.style.scss";
import { ERoleNameUser, IProfileAuthOutputModel } from "interfaces";
import { PAGE_ROUTE } from "constant/routes/page";

const { Header, Sider, Content } = Layout;

type P_Props = {};

const ProtectedLayoutPresenter = (props: P_Props) => {
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();
  const profileLocal: IProfileAuthOutputModel = JSON.parse(localStorage.getItem(STORAGE.LOCAL_PROFILE) || '""');
  const pathName = window.location.pathname;

  const findActiveRoute = (list: typeof pageRoutes) => {
    let result: typeof pageRoutes = [];
    list.forEach((i) => {
      const foundRoute = i.path === pathName;
      if (foundRoute) {
        result.push(i);
      }
      if (i.children) {
        result = [...result, ...findActiveRoute(i.children)];
        return;
      }
    });
    return result;
  };
  const pageRoute = () => {
    const foundRouteList = findActiveRoute(pageRoutes);
    if (foundRouteList.length) {
      const routeList = foundRouteList.at(-1);
      if (routeList && routeList?.path) {
        let pathName = window.location.pathname;
        if (window.location.search) {
          pathName = pathName + window.location.search;
        }
        setPathname(pathName);
      }
      return routeList;
    }
    return null;
  };

  useEffect(() => {
    const accessToken = TokenStorageService.getAccessToken();
    if (!accessToken) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    //eslint-disable-next-line
  }, []);

  const setPathname = (path: string) => {
    StorageUtil.setItem(STORAGE.LOCAL_PATH_NAME, path);
  };

  return (
    <Layout className="layout-protected">
      <Sider className="sidebar" trigger={null} collapsible collapsed={collapsed} theme="light" width={240}>
        <div className="sidebar__header">
          <div></div>
          {!collapsed && (
            <img src={IcoLogoBlue} alt="logo" style={{ alignItems: "center", alignSelf: "center", width: "6rem" }} />
          )}
          {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
            className: "sidebar__header__toggle",
            style: { fontSize: 22, color: "#97A0AF", margin: collapsed ? "auto" : "unset", marginTop: 26 },
            onClick: () => setCollapsed(!collapsed),
          })}
        </div>
        <div className="sidebar__menu">
          {pageRoutes
            .filter((i) => {
              const pathUserExclude = [PAGE_ROUTE.ADM_MEDIA, PAGE_ROUTE.ADM_LEAD];
              if (pathUserExclude.includes(i.path)) {
                if (profileLocal.roleName === ERoleNameUser.USER) return false;
              }
              return true;
            })
            .map((i, idx) => {
              const isActive = pathName.includes(i.path);
              const Icon = i.icon?.length ? i.icon[0] : null;
              const IconActive = i.icon?.length ? i.icon[1] : null;

              return (
                <div
                  key={idx}
                  className={clsx({ sidebar__menu__item: true, active: isActive })}
                  onClick={() => {
                    setPathname(i.path);
                    navigate(i.path);
                  }}
                >
                  <div className="sidebar__menu__item__icon">{isActive ? <IconActive /> : <Icon />}</div>
                  {!collapsed && <span>{i.title}</span>}
                </div>
              );
            })}
        </div>
      </Sider>

      <Layout className="layout-protected__content">
        <Header style={{ height: 74, backgroundColor: "#1E4468", padding: "0 30px" }}>
          <ProtectedHeader title={pageRoute()?.title || ""} />
        </Header>
        <Content>
          <Outlet context={{ collapsed: false, pageRoute: pageRoute() } as ContextModule} />
        </Content>
      </Layout>
    </Layout>
  );
};

export default ProtectedLayoutPresenter;
